import { Reveal } from "@/components/Reveal";
import { MapPin } from "lucide-react";

const DENVER = [
  "Wash Park", "Cherry Creek", "Park Hill", "Highland", "LoDo", "RiNo",
  "Berkeley", "Sloan Lake", "Stapleton / Central Park", "Hilltop",
  "Belcaro", "Crestmoor", "Bonnie Brae",
];

const SUBURBS = [
  "Centennial", "Aurora", "Englewood", "Lakewood", "Arvada", "Westminster",
  "Thornton", "Highlands Ranch", "Castle Rock", "Parker",
];

const Pill = ({ label, i }) => (
  <Reveal delay={(i % 8) * 0.03}>
    <span
      data-testid={`area-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
      className="group inline-flex items-center gap-2 border border-neutral-300 px-4 py-2.5 text-sm text-neutral-800 hover:border-kw-red hover:text-kw-red transition-colors duration-300"
    >
      <MapPin size={13} className="text-kw-red" />
      {label}
    </span>
  </Reveal>
);

export const AreasServed = () => {
  return (
    <section id="areas" data-testid="areas-section" className="bg-[#FAFAFA] border-y border-neutral-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
          <Reveal className="lg:col-span-8">
            <p className="overline text-kw-red mb-4">Areas I Serve</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink leading-[1.02]">
              Deep local expertise across Denver and the surrounding metro.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-neutral-600 leading-relaxed">
              From the heart of the city to the growing suburbs, I know these neighborhoods, their
              pricing, and what it takes to win in each market.
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <p className="overline text-neutral-500 mb-5">Denver Neighborhoods</p>
            <div className="flex flex-wrap gap-3">
              {DENVER.map((n, i) => <Pill key={n} label={n} i={i} />)}
            </div>
          </div>
          <div className="lg:col-span-5">
            <p className="overline text-neutral-500 mb-5">Surrounding Suburbs</p>
            <div className="flex flex-wrap gap-3">
              {SUBURBS.map((n, i) => <Pill key={n} label={n} i={i} />)}
            </div>
          </div>
        </div>

        <Reveal delay={0.15}>
          <p className="mt-12 text-sm text-neutral-500">
            Don't see your neighborhood? I work throughout the greater Denver metro —{" "}
            <a href="#contact" className="text-kw-red hover:text-kw-redhover transition-colors font-medium">
              reach out and let's talk
            </a>.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
